import { defineComponent as _defineComponent } from 'vue'
import {PropType} from 'vue';
import {OrderItem} from '@/types/OrderItem';
import {BundleContent} from '@/types/BundleContent';
import {MappedOrderLines} from "@/types/WavePicking";


export default /*#__PURE__*/_defineComponent({
  __name: 'PackingContentsV2',
  props: {
  orderItems: Array as PropType<OrderItem[]|BundleContent[]|MappedOrderLines[]>,
  showQuantity: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})